import { useState } from "react";
import { Link } from "react-router-dom";
import EventCard from "@/components/feature/EventCard";
import { categories, events } from "@/mocks/content";

export default function EventsExplorer() {
  const [active, setActive] = useState<string>("all");
  const [visible, setVisible] = useState<number>(6);

  const filtered =
    active === "all" ? events : events.filter((e) => e.categoryId === active);
  const shown = filtered.slice(0, visible);

  return (
    <section
      className="w-full border-y border-background-200/70 bg-background-100/60 px-4 py-14 md:px-8 md:py-20"
      aria-labelledby="events-title"
    >
      <div className="mb-8 flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="text-xs font-medium uppercase tracking-[0.2em] text-primary-600">
            Hot Events
          </p>
          <h2
            id="events-title"
            className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl"
          >
            热门事件精选
          </h2>
        </div>
        <Link
          to="/events"
          className="flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 transition-colors hover:text-primary-600"
        >
          查看全部事件
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="mb-8 flex flex-wrap gap-2">
        <button
          type="button"
          onClick={() => {
            setActive("all");
            setVisible(6);
          }}
          className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
            active === "all"
              ? "bg-foreground-950 text-background-50"
              : "bg-background-50 text-foreground-700 hover:bg-primary-50 hover:text-primary-700"
          }`}
        >
          全部
        </button>
        {categories.map((cat) => (
          <button
            key={cat.id}
            type="button"
            onClick={() => {
              setActive(cat.id);
              setVisible(6);
            }}
            className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
              active === cat.id
                ? "bg-foreground-950 text-background-50"
                : "bg-background-50 text-foreground-700 hover:bg-primary-50 hover:text-primary-700"
            }`}
          >
            {cat.name}
          </button>
        ))}
      </div>

      {shown.length === 0 ? (
        <p className="rounded-lg border border-dashed border-background-300 py-16 text-center text-sm text-foreground-500">
          该分类暂时没有事件，换个分类看看吧。
        </p>
      ) : (
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {shown.map((item) => (
            <EventCard
              key={item.slug}
              slug={item.slug}
              title={item.title}
              summary={item.summary}
              cover={item.cover}
              category={item.category}
              date={item.date}
              heat={item.heat}
            />
          ))}
        </div>
      )}

      {visible < filtered.length && (
        <div className="mt-10 flex justify-center">
          <button
            type="button"
            onClick={() => setVisible((v) => v + 6)}
            className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300/80 bg-background-50 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            <i className="ri-add-line"></i>
            加载更多事件
          </button>
        </div>
      )}
    </section>
  );
}